<template>
  <nav class="mobile-nav" aria-label="Mobile Main Navigation">
    <ul class="mobile-nav__menu container" role="menubar">
      <mobile-menu-root-item v-for="(rootItem, index) in nav.main" :key="`root-item-${index}`" :item="rootItem" :route="route" />
    </ul>
    <ul class="mobile-nav__secondary-menu container" role="menubar">
      <mobile-menu-root-item v-for="(rootItem, index) in nav.secondary" :key="`root-secondary-item-${index}`" :item="rootItem" :route="route" />
    </ul>
    <div class="mobile-nav__extras">
      <app-header-extras class="container" />
    </div>
  </nav>
</template>
<script setup lang="ts">
import MobileMenuRootItem from '~/components/ui/layout/mobile-menu/MobileMenuRootItem.vue';
import AppHeaderExtras from '~/components/ui/layout/AppHeaderExtras.vue';

const route = useRoute();
defineProps({
  nav: {
    type: Object,
    required: true,
  },
});
</script>
